module.exports = __webpack_public_path__ + "img/20230403140652951gqd.3dde6149.jpg";